(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("26bsd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $187506d5b1cfb700$export$71511d61b312f219; });

var $afUn2 = parcelRequire("afUn2");

var $giCaB = parcelRequire("giCaB");

var $220cd = parcelRequire("220cd");

var $aCRvb = parcelRequire("aCRvb");
function $187506d5b1cfb700$export$71511d61b312f219(arr) {
    return (0, $afUn2._)(arr) || (0, $giCaB._)(arr) || (0, $aCRvb._)(arr) || (0, $220cd._)();
}

});
parcelRegister("afUn2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7777081c2a4b1a86$export$71511d61b312f219; });

var $IChKS = parcelRequire("IChKS");
function $7777081c2a4b1a86$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $IChKS._)(arr);
}

});
parcelRegister("IChKS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0861ceda66c08a50$export$71511d61b312f219; });
function $0861ceda66c08a50$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("giCaB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bddbef8d2db60240$export$71511d61b312f219; });
function $bddbef8d2db60240$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("220cd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $17abeb9ade6216e7$export$71511d61b312f219; });
function $17abeb9ade6216e7$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("aCRvb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7bc6f45e6716f784$export$71511d61b312f219; });

var $IChKS = parcelRequire("IChKS");
function $7bc6f45e6716f784$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $IChKS._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $IChKS._)(o, minLen);
}

});


parcelRegister("cfDUW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8eb5d989c6289577$export$2e2bcd8739ae039; });
/**
 * Fire function on DOM ready
 *
 * This implementation is coming from https://gomakethings.com/a-native-javascript-equivalent-of-jquerys-ready-method/
 *
 * @param {Function} fn Callback function to run.
 */ var $8eb5d989c6289577$var$onReady = function(fn) {
    if (typeof fn !== 'function') return;
    if (document.readyState === 'interactive' || document.readyState === 'complete') return fn();
    document.addEventListener('DOMContentLoaded', fn, false);
};
var $8eb5d989c6289577$export$2e2bcd8739ae039 = $8eb5d989c6289577$var$onReady;

});

parcelRegister("1FBxg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1376bc92f02b5b83$export$2e2bcd8739ae039; });

var $26bsd = parcelRequire("26bsd");
var $1376bc92f02b5b83$var$debounce = function(callback, wait) {
    var timeoutId = null;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(function() {
            callback.apply(void 0, (0, $26bsd._)(args));
        }, wait);
    };
};
var $1376bc92f02b5b83$export$2e2bcd8739ae039 = $1376bc92f02b5b83$var$debounce;

});

/**
 * Pill Tabs JavaScript
 *
 * This file defines Pill Tabs
 * behavior.
 */ /**
 * Import dependencies and globally-available functions
 */ 
var $26bsd = parcelRequire("26bsd");

var $cfDUW = parcelRequire("cfDUW");

var $1FBxg = parcelRequire("1FBxg");
var /**
 * Set up tab navigation animations
 */ $5a6d1ee74e8fae68$var$_document_querySelectorAll;
var $5a6d1ee74e8fae68$var$tabs = window.aquaminTabs;
/**
 * Set up tabs for inner accordions
 */ $5a6d1ee74e8fae68$var$tabs('pill-tabs', {
    expandFirstTab: true,
    oneAlwaysOpen: true,
    selectors: {
        wrap: '.js-pill-tabs',
        toggles: '.js-pill-tabs-button',
        content: '.js-pill-tabs-content'
    }
});
($5a6d1ee74e8fae68$var$_document_querySelectorAll = document.querySelectorAll('.js-pill-tabs')) === null || $5a6d1ee74e8fae68$var$_document_querySelectorAll === void 0 ? void 0 : $5a6d1ee74e8fae68$var$_document_querySelectorAll.forEach(function(tab) {
    // grab the dom nodes
    var buttons = tab.querySelectorAll('.js-pill-tabs-button');
    var pill = tab.querySelector('.js-pill-tabs-pill');
    // move the pill to a button's position
    var movePill = function(button) {
        pill.style.setProperty('--w', "".concat(button.offsetWidth, "px"));
        pill.style.setProperty('--x', "".concat(button.offsetLeft, "px"));
    };
    // trigger move on click of a tab button
    buttons === null || buttons === void 0 ? void 0 : buttons.forEach(function(button) {
        button.addEventListener('click', function() {
            movePill(button);
        });
    });
    // trigger move on page ready
    (0, $cfDUW.default)(function() {
        return movePill(buttons[0]);
    });
    // trigger move on window load again (seems to have a hard time on the first try... sometimes)
    window.addEventListener('load', function() {
        return movePill(buttons[0]);
    });
    // trigger again (throttled for performance) on resize
    window.addEventListener('resize', (0, $1FBxg.default)(function() {
        var curButton = (0, $26bsd._)(buttons).find(function(button) {
            return button.getAttribute('aria-selected') === 'true';
        });
        movePill(curButton);
    }, 300));
});

})();
//# sourceMappingURL=pill-tabs-script.js.map
